import { styles } from "./PersonalDataView.styles";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@material-ui/core/Typography/Typography";
import { CssBaseline, WithStyles, withStyles } from "@material-ui/core";
import { PersonalDetailsForm } from "./PersonalDetailsForm";
import * as UserDetailsAction from "../../../stores/user/UserDetailsAction";
import { useAuthContext } from "../../../auth/AuthProvider";
import { useTranslation } from "react-i18next";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import ToastStatusEnum from "../../../constants/ToastStatusEnum";
import { useSnackbar } from "notistack";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { useParams } from "react-router-dom";

export interface IPersonalDataViewProps extends WithStyles<typeof styles> {
}

const PersonalDataViewPure: React.FunctionComponent<IPersonalDataViewProps> = ({classes}) => {
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;
    const {t} = useTranslation();

    const {enqueueSnackbar} = useSnackbar();

    const dispatch = useDispatch();
    const userDetails = useSelector(state => state.userDetails?.currentlyLoggedUser);

    useEffect(() => {
        dispatch(UserDetailsAction.requestCurrentUser(userId));
    }, [dispatch, userId]);

    const handleUserDetailsSave = updatedUserDetails => {
        dispatch(UserDetailsAction.editUser(updatedUserDetails)).then(() => {
            enqueueSnackbar(t("manageAccount.personalData.successMessage"), {variant: ToastStatusEnum.Info});
        })
        .catch(e => {
            enqueueSnackbar(`Personal data update failed - ${e.message}` , {variant: ToastStatusEnum.Error});
        })
        
    };

    const relevantUserDetails = !userDetails
        ? null
        : {
            id: userDetails.id,
            email: userDetails.email,
            additionalEmail2: userDetails.additionalEmail2,
            additionalEmail2Verified: userDetails.additionalEmail2Verified,
            additionalEmail3: userDetails.additionalEmail3,
            additionalEmail3Verified: userDetails.additionalEmail3Verified,
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            phone: userDetails.phone,
            mobilePhone: userDetails.mobilePhone,
            company: userDetails.company,
            tin: userDetails.tin,
            billingAddress: userDetails.billingAddress,
            deliveryAddress: userDetails.deliveryAddress,
            userName: userDetails.username
        };

    const {redirect} = useParams();

    return (
        relevantUserDetails && (
                <CenteredContainer>
                    <CssBaseline />
                    <Breadcrumbs
                        items={[
                            {title: t("manageAccount.myAccount"), href: "/my-account"},
                            {title: t("manageAccount.personalData.personalData")}
                        ]}
                    />

                    <div className={classes.title}>
                        <Typography variant="h2">{t("manageAccount.personalData.personalData")}</Typography>
                    </div>
                    <div className={classes.paper}>
                        <PersonalDetailsForm onSave={handleUserDetailsSave} userDetails={relevantUserDetails} fromCheckout={redirect}/>
                    </div>
                </CenteredContainer>
        )
    );
};

export const PersonalDataView = withStyles(styles)(PersonalDataViewPure);
